// client/src/components/pages/PrivacyPolicyPage.js
import React, { useState, useEffect } from 'react';
import './LegalPage.css'; // Using the shared stylesheet

const PrivacyPolicyPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`legal-page-wrapper ${isVisible ? 'is-visible' : ''}`}>
      <div className="legal-page-container">
        <h1>Privacy Policy</h1>
        <span className="last-updated">Last Updated: July 25, 2025</span>

        <h2>1. Introduction</h2>
        <p>Welcome to Makah Medics ("we," "our," or "us"). We are committed to protecting the privacy of our website visitors and clients. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.</p>
        
        <h2>2. Data We Collect</h2>
        <p>We may collect personal information that you voluntarily provide to us when you:</p>
        <ul>
          <li>Fill out the "Request a Quote" form: This includes your full name, company/hospital name, email address, phone number, and the product(s) you are interested in.</li>
          <li>Fill out the "Send Us a Message" form on our Contact page: This includes your full name, email address, subject, and the content of your message.</li>
        </ul>
        <p>We may also automatically collect non-personal information, such as your IP address and browser type, through our server logs for analytical and security purposes.</p>

        <h2>3. How We Use Your Data</h2>
        <p>We use the information we collect solely for the following purposes:</p>
        <ul>
          <li>To respond to your inquiries, questions, and comments.</li>
          <li>To provide you with quotes and information about our products and services.</li>
          <li>To follow up on your requests and maintain a professional relationship.</li>
          <li>To improve our website and services.</li>
        </ul>

        <h2>4. Data Sharing and Disclosure</h2>
        <p>We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. Your data is confidential and is only used by Makah Medics staff to fulfill your requests. This does not include trusted third parties who assist us in operating our website (such as our hosting providers), so long as those parties agree to keep this information confidential.</p>
        
        <h2>5. Cookies and Local Storage</h2>
        <p>Our website uses cookies and browser local storage to deliver a reliable, personalized experience:</p>
        <ul>
          <li><strong>Strictly Necessary Cookies:</strong> Essential for core site operation, security, and submitting quote or contact inquiries.</li>
          <li><strong>Functional & Preference Cookies:</strong> Optionally remember your contact details (such as your name, hospital/company, and phone number) so you do not need to re-type them when requesting multiple equipment quotes.</li>
          <li><strong>Analytics & Embedded Media Cookies:</strong> Support interactive third-party services such as Google Maps directions on our Contact page and anonymous site performance measurement.</li>
        </ul>
        <p>You can review or change your cookie preferences at any time by clicking <strong>"Cookie Settings"</strong> in the website footer.</p>

        <h2>6. Data Security</h2>
        <p>We implement a variety of security measures to maintain the safety of your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee its absolute security.</p>
        
        <h2>7. Your Rights</h2>
        <p>You have the right to request access to the personal data we hold about you and to ask that your personal data be corrected, updated, or deleted. To exercise these rights, please contact us using the information below.</p>
        
        <h2>8. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at:<br/>
        Email: makahmedics@gmail.com<br/>
        Phone: 0778 900 681 / 0779 900 682<br/>
        Address: S.L.P 999, Dar es Salaam, Tanzania</p>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;